import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { htmlToPlainText } from 'shared-helpers/common';
import { ModalButtonWithForm, SortableList } from 'components/common';

import type { AchievementItem } from 'shared-types';

interface Props {
  items: Pick<AchievementItem, 'id' | 'text'>[];
  updateTemplate: () => Promise<void>;
}

const AchievementTemplateOrder = ({ items = [], updateTemplate }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const [order, setOrder] = useState(items?.map((item) => item.id));

  const handleSubmit = async () => {
    const response = await api.put(
      `/admin/achievements/${achievement.id}/template-order`,
      { itemIds: order }
    );

    if (!response.data && !response.data.success) return false;

    await updateTemplate();

    dispatch.addNotice({
      text: messages.commonEditOrderSuccess,
      type: 'success'
    });
    return true;
  };

  return (
    <ModalButtonWithForm
      buttonCategory="lighter"
      buttonDisabled={!items || !items.length}
      buttonIcon="arrows-alt-v"
      buttonProps={{
        'aria-label': messages.commonEditOrder,
        'data-tooltip': messages.commonEditOrder
      }}
      buttonSize="header"
      contentStyle={{ padding: 0 }}
      modalActionCategory="success"
      modalActionText={messages.commonSave}
      modalTitle={messages.commonEditOrder}
      onSubmit={handleSubmit}
    >
      {() => (
        <SortableList
          items={
            items?.length
              ? items.map((item) => ({
                  key: item.id,
                  label: htmlToPlainText(item.text)
                }))
              : []
          }
          itemWithBorder={true}
          listId="achievement-template-order"
          onChange={(keys) => setOrder(keys)}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default AchievementTemplateOrder;
